/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { rgba } from 'polished';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import breakpoint from 'styled-components-breakpoint';

import MainNavigationLinkStyle from './MainNavigationLinkStyle';
import P from './P';
import Block from './Block';

const NavLink = styled(Link)`
  ${MainNavigationLinkStyle}
`;
const SubLinks = styled(Block)`
  ${breakpoint('tablet')`
    position: absolute;
    display: ${({ isSticky }) => (isSticky ? 'flex' : 'none')};
    background-color: ${({ theme }) => rgba(theme.colors.coral, 0.9)};
    top: 91px;
    left: 0;
    width: 100%;
  `}
`;

const MainNavigationLinkItem = ({
  content: {
    primary: { href, title },
    items,
  },
  localePath,
  isSticky,
  isActive,
  linkcolor,
  onNavigation,
}) => {
  const toPath = `${localePath}${href.url}/`;
  const submenuLinks = items.filter(
    ({ sublink_title, sublink_href }) =>
      Boolean(sublink_title) && sublink_href.url.includes('https://internal'),
  );
  const hasSubmenu = Boolean(submenuLinks.length);

  return (
    <>
      {href.link_type === 'Web' ? null : (
        <NavLink
          to={toPath}
          activeClassName="active"
          linkcolor={linkcolor}
          onClick={onNavigation}
        >
          <span>{title}</span>
        </NavLink>
      )}

      {hasSubmenu && isActive && (
        <SubLinks isSticky={isSticky}>
          {submenuLinks.map(({ sublink_title, sublink_href }) => {
            const internalAnchor = sublink_href.url.replace(
              /https:\/\/internal\//g,
              '',
            );

            return (
              <AnchorLink
                key={`sublink-${href.url}-${sublink_href.url}`}
                to={`${toPath}${internalAnchor}`}
                onAnchorLinkClick={onNavigation}
              >
                <P
                  color="white"
                  textAlign="center"
                  isBold
                  px={{ tablet: 'baseDown2' }}
                  py={{ tablet: 'baseDown1' }}
                  mb={{ mobile: 'baseDown2', tablet: '0' }}
                >
                  {sublink_title}
                </P>
              </AnchorLink>
            );
          })}
        </SubLinks>
      )}
    </>
  );
};

MainNavigationLinkItem.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      href: PropTypes.shape({
        url: PropTypes.string.isRequired,
        link_type: PropTypes.string.isRequired,
      }).isRequired,
      title: PropTypes.string,
    }).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  localePath: PropTypes.string.isRequired,
  isSticky: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  linkcolor: PropTypes.string.isRequired,
  onNavigation: PropTypes.func.isRequired,
};

export default MainNavigationLinkItem;
